import React, { useContext } from "react";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";

import { ManageCompleteUserProfileContext } from "./";

const CarrierInfo = () => {
  const [userInfoState, userInfoContextDispatch] = useContext(
    ManageCompleteUserProfileContext
  );
  const userInfo = userInfoState.userInfo;

  const handleInputChange = (e) => {
    let payload = {
      [e.target.name]: e.target.value,
    };
    if (e.target.name === "vehicle_image") {
      payload["vehicle_image_url"] = URL.createObjectURL(e.target.files[0]);
      payload["vehicle_image"] = e.target.files[0];
    }

    userInfoContextDispatch({
      type: "ON_CHANGE",
      payload: payload,
    });

    userInfoContextDispatch({
      type: "CLEAR_ERROR_MESSAGES",
      payload: { [e.target.name]: [] },
    });
  };
  const handleCompanyNameChange = (e) => {
    userInfoContextDispatch({
      type: "ON_CHANGE_USER_INFO",
      payload: {
        [e.target.name]: e.target.value,
      },
    });

    userInfoContextDispatch({
      type: "CLEAR_ERROR_MESSAGES",
      payload: { [e.target.name]: [] },
    });
  };

  // Clean error messages when click on the input
  const hideErrorMessage = (e) => {
    userInfoContextDispatch({
      type: "CLEAR_ERROR_MESSAGES",
      payload: { [e.target.getAttribute("name")]: [] },
    });
  };

  return (
    <div className="row">
      <div className="col-lg-6">
        <div className="input-box-area" single-labe="true">
          <label>Company Name :</label>
          <input
            type="text"
            placeholder="Company Name"
            value={userInfo.user_obj.company_name}
            name="company_name"
            onChange={handleCompanyNameChange}
            onMouseMove={hideErrorMessage}
          />
          <div className="error" show-tittle="true">
            {userInfoState.userInfoError?.company_name.length > 0 ? (
              <div>
                {" "}
                <i className="fa-solid fa-circle-exclamation"></i>{" "}
              </div>
            ) : (
              ""
            )}
            {userInfoState.userInfoError?.company_name?.map((error, index) => (
              <div>
                <p className="auth-error" key={index}>
                  {error}
                </p>
              </div>
            ))}
          </div>
        </div>

        <div className="input-box-area" single-labe="true">
          <label> Carrier Type :</label>
          <div>
            <Select
              label="Load Type"
              value={userInfo.carrier_type}
              name="carrier_type"
              onChange={handleInputChange}
              onMouseMove={hideErrorMessage}
              className="input-box-area-select-field mui-select-field-without-label"
              fullWidth
            >
              <MenuItem value="single_carrier">Single Carrier</MenuItem>
              <MenuItem value="delivery_company">Delivery Company</MenuItem>
            </Select>
          </div>
          <div className="error" show-tittle="true">
            {userInfoState.userInfoError?.carrier_type.length > 0 ? (
              <div>
                {" "}
                <i className="fa-solid fa-circle-exclamation"></i>{" "}
              </div>
            ) : (
              ""
            )}
            {userInfoState.userInfoError?.carrier_type?.map((error, index) => (
              <div>
                <p className="auth-error" key={index}>
                  {error}
                </p>
              </div>
            ))}
          </div>
        </div>

        <div className="input-box-area" single-labe="true">
          <label> Load Type :</label>
          <div>
            <Select
              label="Load Type"
              value={userInfo.load_type}
              name="load_type"
              onChange={handleInputChange}
              onMouseMove={hideErrorMessage}
              className="input-box-area-select-field mui-select-field-without-label"
              fullWidth
            >
              <MenuItem value="pallet">Pallet</MenuItem>
              <MenuItem value="vehicle">Vehicle</MenuItem>
              <MenuItem value="barrel">Barrel</MenuItem>
              <MenuItem value="stones">Stones</MenuItem>
              <MenuItem value="sand">Sand</MenuItem>
              <MenuItem value="laterite">Laterite</MenuItem>
            </Select>
          </div>
          <div className="error" show-tittle="true">
            {userInfoState.userInfoError?.load_type.length > 0 ? (
              <div>
                {" "}
                <i className="fa-solid fa-circle-exclamation"></i>{" "}
              </div>
            ) : (
              ""
            )}
            {userInfoState.userInfoError?.load_type?.map((error, index) => (
              <div>
                <p className="auth-error" key={index}>
                  {error}
                </p>
              </div>
            ))}
          </div>
        </div>

        <div className="input-box-area" single-labe="true">
          <label>Cargo Insurance Company :</label>
          <input
            type="text"
            placeholder="Cargo Insurance Company"
            name="cargo_insurance_company"
            value={userInfo.cargo_insurance_company || ""}
            onChange={handleInputChange}
            onMouseMove={hideErrorMessage}
          />
          <div className="error" show-tittle="true">
            {userInfoState.userInfoError?.cargo_insurance_company.length > 0 ? (
              <div>
                {" "}
                <i className="fa-solid fa-circle-exclamation"></i>{" "}
              </div>
            ) : (
              ""
            )}
            {userInfoState.userInfoError?.cargo_insurance_company?.map(
              (error, index) => (
                <div>
                  <p className="auth-error" key={index}>
                    {error}
                  </p>
                </div>
              )
            )}
          </div>
        </div>

        <div className="input-box-area" single-labe="true">
          <label>Cargo Ins. Limit :</label>
          <input
            type="text"
            name="cargo_Inc_limit"
            value={userInfo.cargo_Inc_limit}
            onChange={handleInputChange}
            onMouseMove={hideErrorMessage}
            placeholder="Cargo Ins. Limit"
          />
          <div className="error" show-tittle="true">
            {userInfoState.userInfoError?.cargo_Inc_limit?.length > 0 ? (
              <div>
                {" "}
                <i className="fa-solid fa-circle-exclamation"></i>{" "}
              </div>
            ) : (
              ""
            )}
            {userInfoState.userInfoError?.cargo_Inc_limit?.map(
              (error, index) => (
                <div>
                  <p className="auth-error" key={index}>
                    {error}
                  </p>
                </div>
              )
            )}
          </div>
        </div>

        <div className="input-box-area" single-labe="true">
          <label>Liability Ins. Limit :</label>
          <input
            type="text"
            name="liability_Inc_limit"
            value={userInfo.liability_Inc_limit}
            onChange={handleInputChange}
            onMouseMove={hideErrorMessage}
            placeholder="Liability Ins. Limit"
          />
          <div className="error" show-tittle="true">
            {userInfoState.userInfoError?.liability_Inc_limit?.length > 0 ? (
              <div>
                {" "}
                <i className="fa-solid fa-circle-exclamation"></i>{" "}
              </div>
            ) : (
              ""
            )}
            {userInfoState.userInfoError?.liability_Inc_limit?.map(
              (error, index) => (
                <div>
                  <p className="auth-error" key={index}>
                    {error}
                  </p>
                </div>
              )
            )}
          </div>
        </div>
      </div>

      <div className="col-lg-6">
        <div className="input-box-area" single-labe="true">
          <label>ICC MC Numbers :</label>
          <input
            type="text"
            name="icc_mc_number"
            value={userInfo.icc_mc_number}
            onChange={handleInputChange}
            placeholder="ICC MC Numbers"
            onMouseMove={hideErrorMessage}
          />
          <div className="error" show-tittle="true">
            {userInfoState.userInfoError?.icc_mc_number?.length > 0 ? (
              <div>
                {" "}
                <i className="fa-solid fa-circle-exclamation"></i>{" "}
              </div>
            ) : (
              " "
            )}
            {userInfoState.userInfoError?.icc_mc_number?.map((error, index) => (
              <div>
                <p className="auth-error" key={index}>
                  {error}
                </p>
              </div>
            ))}
          </div>
        </div>

        <div className="input-box-area" single-labe="true">
          <label>Agent Phone :</label>

          <div className="phone-number-input-area">
            <input
              type="text"
              defaultValue="+1"
              disabled="true"
              className="phone-number-input-code"
            />
            <input
              type="text"
              name="agent_phone"
              value={userInfo.agent_phone}
              onChange={handleInputChange}
              onMouseMove={hideErrorMessage}
              placeholder="e.g. 6505552672"
            />
          </div>
          <div className="error" show-tittle="true">
            {userInfoState.userInfoError?.agent_phone?.length > 0 ? (
              <div>
                {" "}
                <i className="fa-solid fa-circle-exclamation"></i>{" "}
              </div>
            ) : (
             " "
            )}
            {userInfoState.userInfoError?.agent_phone?.map((error, index) => (
              <div>
                <p className="auth-error" key={index}>
                  {error}
                </p>
              </div>
            ))}
          </div>
        </div>

        <div className="input-box-area" single-labe="true">
          <label>Ins Deductible :</label>
          <input
            type="text"
            name="Inc_deductible"
            value={userInfo.Inc_deductible}
            onChange={handleInputChange}
            onMouseMove={hideErrorMessage}
            placeholder="Ins Deductible"
          />
          <div className="error" show-tittle="true">
            {userInfoState.userInfoError?.Inc_deductible?.length > 0 ? (
              <div>
                {" "}
                <i className="fa-solid fa-circle-exclamation"></i>{" "}
              </div>
            ) : (
              " "
            )}
            {userInfoState.userInfoError?.Inc_deductible?.map(
              (error, index) => (
                <div>
                  <p className="auth-error" key={index}>
                    {error}
                  </p>
                </div>
              )
            )}
          </div>
        </div>

        <div className="input-box-area" single-labe="true">
          <label>Cargo Ins. Agent :</label>
          <input
            type="text"
            placeholder="Cargo Ins. Agent"
            name="cargo_Inc_agent"
            value={userInfo.cargo_Inc_agent}
            onChange={handleInputChange}
            onMouseMove={hideErrorMessage}
          />
          <div className="error" show-tittle="true">
            {userInfoState.userInfoError?.cargo_Inc_agent?.length > 0 ? (
              <div>
                {" "}
                <i className="fa-solid fa-circle-exclamation"></i>{" "}
              </div>
            ) : (
              " "
            )}
            {userInfoState.userInfoError?.cargo_Inc_agent?.map(
              (error, index) => (
                <div>
                  <p className="auth-error" key={index}>
                    {error}
                  </p>
                </div>
              )
            )}
          </div>
        </div>

        <div className="input-box-area" single-labe="true">
          <label>Driving Licence :</label>
          <input
            type="text"
            placeholder="Driving Licence"
            name="driving_licence"
            value={userInfo.driving_licence}
            onChange={handleInputChange}
            onMouseMove={hideErrorMessage}
          />
          <div className="error" show-tittle="true">
            {userInfoState.userInfoError?.driving_licence?.length > 0 ? (
              <div>
                {" "}
                <i className="fa-solid fa-circle-exclamation"></i>{" "}
              </div>
            ) : (
              " "
            )}
            {userInfoState.userInfoError?.driving_licence?.map(
              (error, index) => (
                <div>
                  <p className="auth-error" key={index}>
                    {error}
                  </p>
                </div>
              )
            )}
          </div>
        </div>

        <div className="input-box-area" single-labe="true">
          <label>Vehicle Image</label>
          <input
            type="file"
            name="vehicle_image"
            onChange={(e) => {
              handleInputChange(e);
            }}
          />
          <div className="file-info">
            <i className="fas fa-image"></i>
            <span>Choose your image </span>
          </div>
        </div>


        <div className="user-image-update" style={{ width: "100%" }}>
          <img
            src={
              userInfo.vehicle_image_url ? 
              userInfo.vehicle_image_url : '/default-car.jpg'
            }
            alt="img"
          />

          <input
            type="file"
            name="vehicle_image"
            onChange={(e) => {
              handleInputChange(e);
            }}
          />
          <i className="fa-solid fa-camera"></i>
        </div>
      </div>
    </div>
  );
};

export default CarrierInfo;
